// Quick Self-Analysis V1 experiment. rollback = set false + push
export const QUICK_ANALYSIS_V1 = true;
